const ChamadaAcaoSection = () => (
  <section className="texto">
    <h2 style={{ marginTop: '10px', fontSize: '2.5rem', color: '#2d2a7b' }}>Transformando o Futuro</h2>
    <div className="texto-container">
      <p className="texto-paragrafo">
        No Colégio Líder, acreditamos que a educação vai muito além da transmissão de conteúdo. Nosso compromisso é formar
        indivíduos críticos, criativos e preparados para os desafios do mundo moderno. Proporcionamos um ambiente de aprendizado
        que desperta a curiosidade, incentivando nossos alunos a explorarem suas paixões e desenvolverem habilidades essenciais para o futuro.
      </p>
      <p className="texto-paragrafo">
        Com uma infraestrutura moderna, contamos com salas de aula equipadas, espaços inovadores e uma gama de atividades extracurriculares,
        permitindo que os estudantes se expressem, se envolvam e cresçam em diversos campos do saber.
      </p>
      <p className="texto-paragrafo">
        Acreditamos que a educação deve ser uma jornada colaborativa, que envolve a união de alunos, educadores, famílias e a comunidade.
        Nosso ambiente é inclusivo, onde cada voz é ouvida, respeitada e valorizada. Estamos prontos para atender diferentes estilos e
        necessidades de aprendizado, garantindo que todos tenham as mesmas oportunidades de brilhar.
      </p>
      <p className="texto-paragrafo">
        Venha fazer parte dessa transformação! Juntos, podemos construir um futuro brilhante e cheio de possibilidades para nossos alunos.
      </p>
    </div>
    <div className="chamada-para-acao" style={{marginTop: 30 + 'px'}}>
      <a href="https://wa.me/5562998271550" target='_blank' className="cta-button">Faça sua Matrícula Agora!</a>
    </div>
  </section>
);

export default ChamadaAcaoSection;
